function asRecord(value: unknown): Record<string, unknown> | null {
	if (!value || typeof value !== "object" || Array.isArray(value)) return null;
	return value as Record<string, unknown>;
}

function unwrapData(raw: unknown): Record<string, unknown> {
	const root = asRecord(raw) ?? {};
	return asRecord(root.data) ?? root;
}

function asString(value: unknown): string {
	return typeof value === "string" ? value.trim() : "";
}

export interface SignedUrlResponse {
	key: string;
	uploadUrl: string;
	url: string;
	bucket: string;
	contentType: string;
}

export function parseSignedUrlResponse(raw: unknown): SignedUrlResponse {
	const inner = unwrapData(raw);
	return {
		key: asString(inner.key ?? inner.fileKey ?? inner.storageKey ?? inner.path),
		uploadUrl: asString(
			inner.uploadUrl ?? inner.signedUrl ?? inner.presignedUrl,
		),
		url: asString(inner.url ?? inner.fileUrl),
		bucket: asString(inner.bucket),
		contentType: asString(inner.contentType ?? inner.mimeType),
	};
}

export function parseUploadMediaResponse(raw: unknown): {
	bucket: string;
	key: string;
	contentType: string;
	url: string;
} {
	const inner = unwrapData(raw);
	return {
		bucket: asString(inner.bucket),
		key: asString(inner.key ?? inner.fileKey ?? inner.storageKey ?? inner.path),
		contentType: asString(inner.contentType ?? inner.mimeType),
		url: asString(inner.url ?? inner.fileUrl),
	};
}

export function resolveUploadStorageKey(res: { key?: string }): string {
	return res.key?.trim() ?? "";
}
